import { render, staticRenderFns } from "./SpousePartnerUsernameRecovery.vue?vue&type=template&id=263c443f&"
import script from "./SpousePartnerUsernameRecovery.vue?vue&type=script&lang=js&"
export * from "./SpousePartnerUsernameRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports